import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RedeemService } from '../redeem.service';
import { SharedService } from '../../shared/shared.service';
import { LoaderService } from '../../loader.service';
import { AuthService } from '../../auth.service';
import { ToasterService } from '../../toaster.service';
import { Toaster, ToasterType } from '../../shared/types/toaster.types';
import { Table, Pagination, TableActions, TableAction, TableData, TableDataTypes } from '../../shared/types';
import { EDIT_REDEEM } from '../../routes';
var RedeemListComponent = /** @class */ (function () {
    function RedeemListComponent(redeemService, sharedService, loaderService, authService, toastService, router, route) {
        this.redeemService = redeemService;
        this.sharedService = sharedService;
        this.loaderService = loaderService;
        this.authService = authService;
        this.toastService = toastService;
        this.router = router;
        this.route = route;
        this.table = new Table({
            headers: {
                shift: 'Shift',
                cities: 'City',
                modeId: 'Mode',
                startDate: 'Start Date',
                createdDate: 'Created On',
                transactionCount: 'No Of Trans.',
                transactionPeriod: 'Transaction Period',
                minTransactionAmount: 'Min Transaction Amount',
                active: 'Active',
                action: 'Actions'
            },
            pagination: new Pagination(0, 50, 50, [50, 100]),
            data: []
        });
        this.showFilters = true;
        this.requestBody = {
            filters: {},
            sort: ''
        };
        this.cities = [];
        this.shifts = [];
        this.modes = [];
        this.cityMap = {};
        this.modeNameToId = {};
        this.modeIdToName = {};
        this.modesFetchedForCity = new Set();
        this.selectedCityNames = [];
        this.selectedModeNames = [];
        this.citiesFilter = {
            type: 'searchable-dropdown',
            title: 'City',
            values: [],
            default: [],
            key: 'redeem-city',
            initialSelected: []
        };
        this.modesFilter = {
            type: 'searchable-dropdown',
            title: 'Mode',
            values: [],
            default: [],
            key: 'redeem-mode',
            initialSelected: []
        };
        this.shiftsFilter = {
            type: 'searchable-dropdown',
            title: 'Shift',
            values: [],
            default: [],
            key: 'redeem-shift',
            initialSelected: []
        };
        this.filterComponents = [this.citiesFilter, this.modesFilter, this.shiftsFilter];
        // Columns the upstream supports sorting on (mirrors the legacy ng-table sortable columns).
        this.sortableColumns = ['startDate', 'createdDate', 'active'];
    }
    RedeemListComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var permissions, appliedLaunchFilters;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.getPermissions()];
                    case 1:
                        permissions = _a.sent();
                        if (!permissions || permissions.indexOf('redeem_list') < 0) {
                            this.toastService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: 'You are not authorized to access this page'
                            }));
                            this.router.navigate(['/']);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.fetchAllCities()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.applyLaunchQueryParamsToFilters()];
                    case 3:
                        appliedLaunchFilters = _a.sent();
                        if (!!appliedLaunchFilters) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.fetchTableData()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Prefill list filters from CSCC launch query (`city` + `mode`) and apply them.
    RedeemListComponent.prototype.applyLaunchQueryParamsToFilters = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var q, cityId, modeId, city, cityDisplayName, modeName;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        q = this.route.snapshot.queryParamMap;
                        cityId = (q.get('city') || '').trim();
                        modeId = (q.get('mode') || '').trim();
                        if (!cityId) {
                            this.showFilters = false;
                            return [2 /*return*/, false];
                        }
                        city = this.cities.find(function (c) { return String(c._id) === String(cityId); });
                        if (!city) {
                            this.showFilters = false;
                            return [2 /*return*/, false];
                        }
                        cityDisplayName = city.displayName;
                        this.selectedCityNames = [cityDisplayName];
                        this.citiesFilter = tslib_1.__assign({}, this.citiesFilter, { initialSelected: [cityDisplayName], default: [cityDisplayName] });
                        return [4 /*yield*/, this.fetchModesForCitiesAsync([cityDisplayName])];
                    case 1:
                        _a.sent();
                        if (!modeId) {
                            this.toastService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: 'Mode is required in launch URL.',
                            }));
                            this.refreshFilterComponents();
                            this.showFilters = true;
                            this.applyFilters({
                                'redeem-city': this.selectedCityNames,
                                'redeem-mode': [],
                                'redeem-shift': []
                            });
                            return [2 /*return*/, true];
                        }
                        modeName = this.modeIdToName[modeId]
                            || Object.keys(this.modeNameToId).find(function (name) { return String(_this.modeNameToId[name]) === String(modeId); })
                            || '';
                        if (!modeName) {
                            this.toastService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: 'Invalid mode in launch URL for the selected city.',
                            }));
                            this.refreshFilterComponents();
                            this.showFilters = true;
                            this.applyFilters({
                                'redeem-city': this.selectedCityNames,
                                'redeem-mode': [],
                                'redeem-shift': []
                            });
                            return [2 /*return*/, true];
                        }
                        this.selectedModeNames = [modeName];
                        this.modesFilter = tslib_1.__assign({}, this.modesFilter, { initialSelected: [modeName], default: [modeName] });
                        this.fetchShiftsForCityModes(this.selectedCityNames, this.selectedModeNames);
                        this.refreshFilterComponents();
                        this.showFilters = true;
                        this.applyFilters({
                            'redeem-city': this.selectedCityNames,
                            'redeem-mode': this.selectedModeNames,
                            'redeem-shift': []
                        });
                        return [2 /*return*/, true];
                }
            });
        });
    };
    RedeemListComponent.prototype.refreshFilterComponents = function () {
        this.filterComponents = [this.citiesFilter, this.modesFilter, this.shiftsFilter];
    };
    RedeemListComponent.prototype.fetchModesForCitiesAsync = function (cityDisplayNames) {
        var _this = this;
        this.modes = [];
        this.modeNameToId = {};
        this.updateModeFilterValues([]);
        this.updateShiftFilterValues([]);
        if (!cityDisplayNames.length) {
            return Promise.resolve();
        }
        var requests = cityDisplayNames.map(function (displayName) {
            var cityId = _this.cityMap[displayName];
            if (!cityId) {
                return Promise.resolve();
            }
            return _this.sharedService.fetchModes(cityId).toPromise().then(function (res) {
                var modes = (res && res.data && res.data.modes) || [];
                for (var _i = 0, modes_1 = modes; _i < modes_1.length; _i++) {
                    var m = modes_1[_i];
                    if (m && m.name && m.id != null) {
                        _this.modeNameToId[m.name] = m.id;
                        _this.modeIdToName[m.id] = m.name;
                    }
                }
                _this.modes = Object.keys(_this.modeNameToId);
                _this.updateModeFilterValues(_this.modes);
            }).catch(function () { return undefined; });
        });
        return Promise.all(requests).then(function () { return undefined; });
    };
    RedeemListComponent.prototype.withLoader = function (cb) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        this.loaderService.openLoading();
                        return [4 /*yield*/, cb()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RedeemListComponent.prototype.fetchAllCities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var citiesRes;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.withLoader(function () { return _this.sharedService.fetchCities().toPromise(); })];
                    case 1:
                        citiesRes = _a.sent();
                        this.cities = (citiesRes.data.cities || []).filter(function (c) { return c.active; });
                        this.citiesFilter.values = this.cities.map(function (city) { return city.displayName; });
                        this.cityMap = {};
                        this.cities.forEach(function (city) { _this.cityMap[city.displayName] = city._id; });
                        return [2 /*return*/];
                }
            });
        });
    };
    RedeemListComponent.prototype.onFilterChange = function ($evt) {
        if (!$evt) {
            return;
        }
        if ('redeem-city' in $evt) {
            this.selectedCityNames = Array.isArray($evt['redeem-city']) ? $evt['redeem-city'] : [];
            this.fetchModesForCities(this.selectedCityNames);
            this.fetchShiftsForCityModes(this.selectedCityNames, this.selectedModeNames);
        }
        if ('redeem-mode' in $evt) {
            this.selectedModeNames = Array.isArray($evt['redeem-mode']) ? $evt['redeem-mode'] : [];
            this.fetchShiftsForCityModes(this.selectedCityNames, this.selectedModeNames);
        }
    };
    RedeemListComponent.prototype.fetchModesForCities = function (cityDisplayNames) {
        var _this = this;
        this.modes = [];
        this.modeNameToId = {};
        this.updateModeFilterValues([]);
        this.updateShiftFilterValues([]);
        if (!cityDisplayNames.length) {
            return;
        }
        for (var _i = 0, cityDisplayNames_1 = cityDisplayNames; _i < cityDisplayNames_1.length; _i++) {
            var displayName = cityDisplayNames_1[_i];
            var cityId = this.cityMap[displayName];
            if (cityId) {
                this.sharedService.fetchModes(cityId).subscribe(function (res) {
                    var modes = (res && res.data && res.data.modes) || [];
                    for (var _i = 0, modes_2 = modes; _i < modes_2.length; _i++) {
                        var m = modes_2[_i];
                        if (m && m.name && m.id != null) {
                            _this.modeNameToId[m.name] = m.id;
                        }
                    }
                    _this.modes = Object.keys(_this.modeNameToId);
                    _this.updateModeFilterValues(_this.modes);
                });
            }
        }
    };
    RedeemListComponent.prototype.updateModeFilterValues = function (values) {
        this.modesFilter = tslib_1.__assign({}, this.modesFilter, { values: values });
        this.refreshFilterComponents();
    };
    RedeemListComponent.prototype.fetchShiftsForCityModes = function (cityDisplayNames, modeNames) {
        var _this = this;
        this.shifts = [];
        if (!cityDisplayNames.length || !modeNames.length) {
            this.updateShiftFilterValues([]);
            return;
        }
        var shiftSet = new Set();
        for (var _i = 0, cityDisplayNames_2 = cityDisplayNames; _i < cityDisplayNames_2.length; _i++) {
            var cityName = cityDisplayNames_2[_i];
            var cityId = this.cityMap[cityName];
            if (!cityId) {
                continue;
            }
            for (var _a = 0, modeNames_1 = modeNames; _a < modeNames_1.length; _a++) {
                var modeName = modeNames_1[_a];
                var modeId = this.modeNameToId[modeName];
                if (!modeId) {
                    continue;
                }
                this.sharedService.fetchCaptainEarningsShifts(cityId, modeId, false).subscribe(function (res) {
                    _this.extractShiftNames(res).forEach(function (name) { return shiftSet.add(name); });
                    _this.shifts = Array.from(shiftSet);
                    _this.updateShiftFilterValues(_this.shifts);
                });
            }
        }
    };
    RedeemListComponent.prototype.extractShiftNames = function (res) {
        var arr = [];
        if (res && res.data && Array.isArray(res.data.shifts)) {
            arr = res.data.shifts;
        }
        else if (res && Array.isArray(res.data)) {
            arr = res.data;
        }
        else if (Array.isArray(res)) {
            arr = res;
        }
        return arr
            .map(function (s) { return (typeof s === 'object' && s !== null) ? (s.name || '') : String(s); })
            .filter(function (name) { return name.trim() !== ''; });
    };
    RedeemListComponent.prototype.updateShiftFilterValues = function (values) {
        this.shiftsFilter = tslib_1.__assign({}, this.shiftsFilter, { values: values });
        this.refreshFilterComponents();
    };
    // Free-text shift search, mirroring the legacy `<field>__regex` ng-table column filter.
    RedeemListComponent.prototype.searchByShift = function () {
        this.table.pagination.setPageNoToZero();
        var shift = (this.shiftSearch || '').trim();
        this.requestBody.filters = shift ? { shift__regex: shift } : {};
        this.fetchTableData();
    };
    RedeemListComponent.prototype.applyFilters = function (filters) {
        var _this = this;
        this.table.pagination.setPageNoToZero();
        var filtersRequest = {};
        if ((filters['redeem-city'] || []).length > 0) {
            filtersRequest.cities__in = filters['redeem-city'].join(',');
        }
        var selectedShifts = filters['redeem-shift'] || [];
        var selectedModeIds = (filters['redeem-mode'] || [])
            .map(function (name) { return _this.modeNameToId[name]; })
            .filter(function (id) { return !!id; });
        if (selectedShifts.length > 0) {
            filtersRequest.shift__in = selectedShifts.join(',');
        }
        else if (selectedModeIds.length > 0) {
            filtersRequest.modeId__in = selectedModeIds.join(',');
        }
        this.requestBody.filters = filtersRequest;
        this.fetchTableData();
    };
    RedeemListComponent.prototype.sortByHeader = function (header) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sortOrder, column;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sortOrder = header.includes('-') ? '-' : '+';
                        column = header.replace('-', '');
                        if (this.sortableColumns.indexOf(column) < 0) {
                            return [2 /*return*/];
                        }
                        this.requestBody.sort = sortOrder + column;
                        return [4 /*yield*/, this.fetchTableData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RedeemListComponent.prototype.fetchTableData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.withLoader(function () { return _this.fetchRedeemRules(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RedeemListComponent.prototype.fetchRedeemRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var perPage, pageNo, queryParams, permissions, response, fetched, hasNextPage, rules, citiesWithMode;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        perPage = this.table.pagination.perPage;
                        pageNo = this.table.pagination.pageNo;
                        queryParams = tslib_1.__assign({ active: true, limit: perPage + 1, offset: perPage * pageNo }, this.requestBody.filters);
                        if (this.requestBody.sort) {
                            queryParams.sort = this.requestBody.sort;
                        }
                        return [4 /*yield*/, this.authService.getPermissions()];
                    case 1:
                        permissions = _a.sent();
                        return [4 /*yield*/, this.redeemService.getRules(queryParams).toPromise()];
                    case 2:
                        response = _a.sent();
                        fetched = (response && response.data) ? response.data : [];
                        hasNextPage = fetched.length > perPage;
                        rules = hasNextPage ? fetched.slice(0, perPage) : fetched;
                        this.table.pagination.count = hasNextPage
                            ? (pageNo + 1) * perPage + 1
                            : pageNo * perPage + rules.length;
                        citiesWithMode = Array.from(new Set(rules.filter(function (r) { return r.modeId; }).reduce(function (acc, r) { return acc.concat(r.cities || []); }, [])));
                        return [4 /*yield*/, this.ensureModeNamesForCities(citiesWithMode)];
                    case 3:
                        _a.sent();
                        this.table.data = rules.map(function (rule) { return ({
                            shift: (rule.shift || []).join(', '),
                            cities: (rule.cities || []).join(', '),
                            modeId: rule.modeId ? (_this.modeIdToName[rule.modeId] || rule.modeId) : '--',
                            startDate: rule.startDate || '--',
                            createdDate: rule.createdDate ? new Date(rule.createdDate).toISOString().slice(0, 10) : '--',
                            transactionCount: rule.transactionCount,
                            transactionPeriod: rule.transactionPeriod,
                            minTransactionAmount: rule.minTransactionAmount,
                            active: rule.active ? 'Active' : 'Deactivate',
                            action: _this.createAction(permissions, rule)
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    RedeemListComponent.prototype.ensureModeNamesForCities = function (cityDisplayNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var toFetch;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toFetch = cityDisplayNames.filter(function (name) { return name && _this.cityMap[name] && !_this.modesFetchedForCity.has(name); });
                        return [4 /*yield*/, Promise.all(toFetch.map(function (displayName) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var res, modes, _i, modes_3, m, e_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.modesFetchedForCity.add(displayName);
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this.sharedService.fetchModes(this.cityMap[displayName]).toPromise()];
                                        case 2:
                                            res = _a.sent();
                                            modes = (res && res.data && res.data.modes) || [];
                                            for (_i = 0, modes_3 = modes; _i < modes_3.length; _i++) {
                                                m = modes_3[_i];
                                                if (m && m.id != null && m.name) {
                                                    this.modeIdToName[m.id] = m.name;
                                                }
                                            }
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_1 = _a.sent();
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RedeemListComponent.prototype.createAction = function (permissions, rule) {
        var _this = this;
        var actionArr = [];
        if (permissions && permissions.indexOf('redeem_edit') >= 0) {
            actionArr.push(new TableAction({
                onClick: function () {
                    _this.openPage('/' + EDIT_REDEEM.replace(':id', rule._id));
                },
                text: 'Edit'
            }));
        }
        return new TableData({
            actions: new TableActions(actionArr),
            type: TableDataTypes.ACTION
        });
    };
    RedeemListComponent.prototype.openPage = function (url) {
        this.router.navigate([url]);
    };
    return RedeemListComponent;
}());
export { RedeemListComponent };
